// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___1pv2I","input":"styles__input___2hAoj","button":"styles__button___16Zfp","copy":"styles__copy___3UwLm","isActive":"styles__isActive___1jkkP"};